import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import { Pencil, Wand2, History } from 'lucide-mui';

interface EditDialogProps {
  open: boolean;
  onClose: () => void;
}

const EditDialog: React.FC<EditDialogProps> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Coming Soon: Edit Transcript Segments</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 3 }}>
          We&apos;re building powerful editing capabilities to help you create
          more accurate transcripts.
        </DialogContentText>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Pencil color="primary" />
            <Typography>
              Edit transcript text directly with real-time updates
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Wand2 color="primary" />
            <Typography>
              Get smart suggestions powered by AI to improve accuracy
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <History color="primary" />
            <Typography>
              Review and restore previous versions anytime
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          sx={{ minWidth: 100 }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditDialog;
